export default __webpack_public_path__ + "static/media/Freewheelerz flyer.c0b71c4d.pdf";